import { GetInvitationResponse } from '@aldebaran/common/types/api';
import { Practice, Professional } from '@aldebaran/prisma';
import { ProfessionalWithPractice } from '@aldebaran/common/types';

import { useClaimInvitation } from './useClaimInvitation';
import { usePractice } from './usePractice';
import { useProfessional } from './useProfessional';

export type EntryType = 'invitation' | 'practice' | 'professional';

export type EntryData =
  | GetInvitationResponse
  | (Practice & { users: Professional[] })
  | ProfessionalWithPractice;

export interface UseEntryDataReturn {
  data: EntryData | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export const useEntryData = (
  entryType: EntryType,
  slug: string,
): UseEntryDataReturn => {
  const invitation = useClaimInvitation(entryType === 'invitation' ? slug : '');
  const practice = usePractice(entryType === 'practice' ? slug : undefined);
  const professional = useProfessional(
    entryType === 'professional' ? slug : undefined,
  );

  switch (entryType) {
    case 'invitation':
      return {
        data: invitation.data,
        isLoading: invitation.isLoading,
        isError: invitation.isError,
        error: invitation.error,
      };
    case 'practice':
      return {
        data: practice.data,
        isLoading: practice.isLoading,
        isError: practice.isError,
        error: practice.error,
      };
    case 'professional':
      return {
        data: professional.data,
        isLoading: professional.isLoading,
        isError: professional.isError,
        error: professional.error,
      };
  }
};
